export const changeContractNoReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_CONTRACT_NO":
        return action.payload.contractNo;
      default:
        return state;
    }
  };
  